import React from 'react';
import { useSelector } from 'react-redux';
import { usePagination, getQueryString } from '../../util/helper-functions';
import './style.scss';
import ICONS from '../icons';

const Pagination = ( {
	totalCount,
	itemsPerPage,
	siblings = 1,
	currentPage,
} ) => {
	const { pattern } = useSelector( ( state ) => state );
	const regex = /\/$/;
	const queryString = getQueryString( window.location.href );
	const pageSlug = AstraShowcaseVars.pageSlug.path.replace( regex, '' );
	const pageQuery = queryString ? '?' + queryString : '';
	const totalPages = Math.ceil( totalCount / itemsPerPage );
	const pageNumbers = usePagination(
		totalCount,
		itemsPerPage,
		siblings,
		currentPage
	);
	const DOTS = '...';
	const disablePrev = currentPage === 1;
	const disableNext = currentPage === totalPages;

	const prevPage = ! disablePrev ? currentPage - 1 : '#';
	const nextPage = ! disableNext ? currentPage + 1 : '#';

	return (
		<div id="pagination" className={ `pagination-wrapper ${ 'pattern2' === pattern ? 'pattern2' : '' }` }>
			<div className="pagination-inner">
				<a
					className={ `previous-page ${
						disablePrev ? 'disabled' : null
					}` }
					href={ `//${ pageSlug }/page/${ prevPage }/${ pageQuery }` }
				>
					{ ICONS.previousPage }
				</a>
				<div className="pagination-links">
					{ pageNumbers.map( ( num ) => {
						return (
							<>
								{ num !== DOTS && (
									<a
										href={ `//${ pageSlug }/page/${ num }/${ pageQuery }` }
										className={ `pagination-link ${
											currentPage === num ? 'active' : ''
										}` }
									>
										{ num }
									</a>
								) }
							</>
						);
					} ) }
				</div>
				<a
					className={ `previous-page ${
						disableNext ? 'disabled' : null
					}` }
					href={ `//${ pageSlug }/page/${ nextPage }/${ pageQuery }` }
				>
					{ ICONS.nextPage }
				</a>
			</div>
		</div>
	);
};

export default Pagination;
